import * as RadixSliderPrimitive from '@radix-ui/react-slider';
import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const Slider = forwardRef<
  React.ElementRef<typeof RadixSliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadixSliderPrimitive.Root>
>(({ children, className, ...rest }, ref) => {
  return (
    <RadixSliderPrimitive.Root
      className={twMerge(
        'relative flex items-center h-4 w-full touch-none select-none',
        className
      )}
      ref={ref}
      {...rest}
    >
      {children}
    </RadixSliderPrimitive.Root>
  );
});

Slider.displayName = 'Slider';

const SliderTrack = forwardRef<
  React.ElementRef<typeof RadixSliderPrimitive.Track>,
  React.ComponentPropsWithoutRef<typeof RadixSliderPrimitive.Track>
>(({ className, children, ...rest }, ref) => {
  return (
    <RadixSliderPrimitive.Track
      ref={ref}
      className={twMerge(
        'flex-grow relative bg-retail-gray-100 rounded-[40px] h-4 w-full',
        className
      )}
      {...rest}
    >
      {children}
    </RadixSliderPrimitive.Track>
  );
});

const SliderRange = forwardRef<
  React.ElementRef<typeof RadixSliderPrimitive.Range>,
  React.ComponentPropsWithoutRef<typeof RadixSliderPrimitive.Range>
>(({ className, ...rest }, ref) => {
  return (
    <RadixSliderPrimitive.Range
      className={twMerge(
        'absolute bg-retail-primary-500 rounded-[40px] h-4',
        className
      )}
      ref={ref}
      {...rest}
    />
  );
});

SliderRange.displayName = 'SliderRange';

SliderTrack.displayName = 'SliderTrack';

const SliderThumb = forwardRef<
  React.ElementRef<typeof RadixSliderPrimitive.Thumb>,
  React.ComponentPropsWithoutRef<typeof RadixSliderPrimitive.Thumb>
>(({ className, ...rest }, ref) => {
  return (
    <RadixSliderPrimitive.Thumb
      ref={ref}
      className={twMerge(
        'h-10 w-14 flex justify-center items-center gap-[3px] bg-retail-primary-700 rounded-[40px] p-2 border-white border-[4px]',
        className
      )}
      {...rest}
    >
      <span className="inline-block h-2 w-[2px] rounded-[32px] bg-white"></span>
      <span className="inline-block h-4 w-[2px] rounded-[32px] bg-white"></span>
      <span className="inline-block h-2 w-[2px] rounded-[32px] bg-white"></span>
    </RadixSliderPrimitive.Thumb>
  );
});

SliderThumb.displayName = 'SliderThumb';

export default Slider;
export { SliderRange, SliderThumb, SliderTrack };
